<template>
    <div class="rb-pass">
        <div class="rb-pass__list flex-between-start">
            <div class="pass-item" v-for="(item, index) in pass_list" :key="index" :class="{'active': phase > index }">
                <div class="rb">
                    <div class="amt">X{{ item.amt }}</div>

                    <div class="status sprite sprite-status-dismiss" v-if="giftRate > index"></div>
                </div>

                <div class="status-dot">
                    <div class="dot sprite sprite-dot_list" :class="{'active': phase > index }"></div>
                </div>

                <div class="cnt">{{ format_num(item.value) }}{{ word }}</div>            
            </div>
        </div>

        <div class="rb-pass__line">
            <div class="bar" :style="barWidth()"></div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            // 你的数据
        };
    },
    props: {
        // 你的属性
        pass_list: {
            type: Array,
            default: () => [],
        },
        phase: {
            type: Number,
            default: 0,
        },
        giftRate: {
            type: Number,
            default: 0,
        },
        word : {
            type: String,
            default: '',
        },
    },
    methods: {
        barWidth() {
            // 计算进度条宽度的逻辑
            if(this.phase <= 0) return 'width: 0;';
            if(this.phase == this.pass_list.length) return 'width: 100%;';

            let imgWidth = this.$global.deviceType == 'pc' ? 125 : 100; // 每个红包图片的宽度
            let boderWidth = this.$global.deviceType == 'pc' ? 50 : 10;
            let dotWidth = 20; // 每个状态点的宽度
            let arrLength = Math.floor(100/this.pass_list.length) * (this.phase - 1);
            
            const line = this.$el && this.$el.querySelector('.rb-pass__line');
            if(!line)return 'width: 0;';

            let lineWidth = line.clientWidth - boderWidth * 2 - imgWidth;
            let avgWidth = lineWidth/(this.pass_list.length - 1);
            
            // return `width: calc(${arrLength}% + ${boderWidth}px + ${dotWidth/2}px + ${imgWidth/2}px);`
            return `width: calc(${avgWidth * (this.phase - 1)}px + ${boderWidth}px + ${imgWidth/2}px);`
        },
        format_num(num){
            return num > 9999 ? (Math.floor(num / 10000)+'万') : num;
        }
    },
}
</script>

<style lang="scss" scoped>
@include responseTo("desktop"){
.rb-pass{
    position: relative;

    &__list{
        width: 1104px;
        margin: 0 auto;
        // todo
        .rb{
            position: relative;
            width: 127px;
            height: 150px;
            margin-bottom: 15px;
            background-image: url(~@/assets/images/pc/item-rb.png);
        }

        .active .rb{
            background-image: url(~@/assets/images/pc/item-rb_act.png);
        }

        .amt{
            position: absolute;
            top: 102px;
            left: 50%;
            transform: translate(-50%, 0);
            width: 63px;
            height: 37px;
            line-height: 37px;
            background-image: url(~@/assets/images/pc/cnt-rb.png);
            font-size: 32px;
            color: #c3ae8d;
            font-family: "HYJinKaiJ";
            font-weight: 400;
            text-align: center;
        }

        .status{
            position: absolute;
            top: 70px;
            left: 50%;
            transform: translateX(-50%);
        }

        .status-dot{
            position: relative;
            margin: 0 auto 10px;
            z-index: 3;

            .dot{
                margin: 0 auto;
            }
        }

        .active .status-dot{
            // top: 5px;
        }

        .cnt{
            text-align: center;
            font-size : 28px;
            font-family: "HYJinKaiJ";
            color: transparent;
            background: linear-gradient(
                180deg,
                #e9695c 0%,
                #eb7c6f 50%,
                #ee8d81 100%
            );
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;            
        }

        .active .cnt{
            color: transparent;
            background: linear-gradient(
                180deg,
                #fff4d6 0%,
                #fee7bf 50%,
                #ed9b58 100%
            );
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

    &__line{
        position: absolute;
        width: 1104px;
        height: 4px;
        left : 50%;
        top : 171px;
        transform: translateX(-50%);
        padding: 0 50px;
        background-color: #762311;
        border-radius: 10px;

        .bar{
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            background-color: #ed4e38;
            border-radius: 10px;            
        }
    }
}
}

@include responseTo("phone"){
.rb-pass{
    position: relative;
    &__list{
        width: 730px;
        margin: 0 auto;
        // todo
        .rb{
            position: relative;
            width: 109px;
            height: 128px;
            margin-bottom: 15px;
            background-image: url(~@/assets/images/m/item-rb.png);
        }

        .active .rb{
            background-image: url(~@/assets/images/m/item-rb_act.png);
        }

        .amt{
            position: absolute;
            top: 82px;
            left: 50%;
            transform: translate(-50%, 0);
            width: 63px;
            height: 37px;
            line-height: 37px;
            background-image: url(~@/assets/images/pc/cnt-rb.png);
            font-size: 32px;
            color: #c3ae8d;
            font-family: "HYJinKaiJ";
            font-weight: 400;
            text-align: center;
        }

        .status{
            position: absolute;
            top: 55px;
            left: 50%;
            transform: translateX(-50%);
        }

        .status-dot{
            position: relative;
            margin: 0 auto 10px;
            z-index: 3;

            .dot{
                margin: 0 auto;
            }
        }

        .active .status-dot{
            // top: 5px;
        }

        .cnt{
            text-align: center;
            font-size : 28px;
            font-family: "HYJinKaiJ";

            color: transparent;
            background: linear-gradient(
                180deg,
                #e9695c 0%,
                #eb7c6f 50%,
                #ee8d81 100%
            );
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;               
        }

        .active .cnt{
            color: transparent;
            background: linear-gradient(
                180deg,
                #fff4d6 0%,
                #fee7bf 50%,
                #ed9b58 100%
            );
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            
        }
    }

    &__line{
        position: absolute;
        width: 750px;
        height: 4px;
        left : 50%;
        top : 149px;
        transform: translateX(-50%);
        padding: 0 10px;
        background-color: #762311;
        border-radius: 10px;

        .bar{
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            background-color: #ed4e38;
            border-radius: 10px;            
        }
    }
}
}
</style>